/**
 * Joins an array of React nodes with a separator, creating a new array suitable for React rendering.
 * Required when rendering a list of components with a separator, because Array.join() would try to convert the components to strings, which would not work correctly and could result in "[object Object]"
 *
 * @param array - Array of React nodes to join
 * @param separator - The separator to insert between elements (default: ', ')
 * @returns An array of alternating elements and separators, or null if the input array is empty
 *
 * @example
 * joinComponents([<span>A</span>, <span>B</span>])
 * // returns [<span>A</span>, ', ', <span>B</span>]
 *
 * joinComponents([], '-') // returns null
 */
export const joinComponents = (array: React.ReactNode[], separator = ', ') => {
  if (!array?.length) {
    return null;
  }

  const result = [array[0]];

  for (const element of array.slice(1)) {
    result.push(separator, element);
  }

  return result;
};
